import { observer } from 'mobx-react';
import * as React from 'react';
import { currentUserStore } from '../../../CurrentUserStore';
import Login from '../../../Login';
import Platform from '../../Platform';
import MainNavSkeleton from '../../Platform/MainNav/MainNavSkeleton';
import AddSectionSkeleton from '../../LearningCollections/LearningCollection/CurrentCollectionStep/BuilderV2/New/AddSectionSkeleton';
import EditSkeleton from '../../LearningCollections/LearningCollection/CurrentCollectionStep/BuilderV2/Edit/EditSkeleton';

const getBuilderV2Skeleton = () => {
  const path = window.location.pathname;
  // New page: exact match (no ID suffix)
  if (path === '/learning_collections/builder_v2') {
    return <AddSectionSkeleton />;
  }
  // Edit page: has an ID after builder_v2/
  if (path.startsWith('/learning_collections/builder_v2/')) {
    return <EditSkeleton />;
  }
  return null;
};

const CurrentUserStateView: React.FC = () => {
  switch (currentUserStore.currentUserState.kind) {
    case 'anonymous':
    case 'unauthorized':
    case 'errored':
      return <Login currentUserState={currentUserStore.currentUserState} />;
    case 'waiting':
    case 'identifying':
    case 'logging-out':
      // Show appropriate skeleton based on route
      return getBuilderV2Skeleton() ?? <MainNavSkeleton />;
    case 'identified':
      return <Platform />;
  }
};

export default observer(CurrentUserStateView);
